import mapActions from './mapActions';

export default mapActions('building_last_performances', {
    fetchAll_url: data => `/api/buildings/${data.building_id}/last_performances`
});